import FeesCard from "./FeesCard";

export default function Class3() {
  return (
    <FeesCard
        badge="Class 3"
        title="💰 Class 3 Tuition Details"
        className="3rd Standard"
        fee="₹1,000"
        days="Monday – Saturday"
        time="4:30 PM – 7:30 PM"
        subjects={[
          "English",
          "Mathematics",
          "EVS",
          "Writing practice"
        ]}
        approach={[
          "Concept clarity",
          "Daily practice",
          "Regular assessments"
        ]}
        note="₹500 extra for evening snacks / milk.
        Self pickup & drop only."
      />
    
  );
}